module.exports = __webpack_public_path__ + "img/home_story_card3.90eedce2.svg";